/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialog_Rename_AudioInputs */

const en_dialog_rename_audio = /** @type {(inputs: Dialog_Rename_AudioInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rename Audio`)
};

const es_dialog_rename_audio = /** @type {(inputs: Dialog_Rename_AudioInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Renombrar audio`)
};

/**
* | output |
* | --- |
* | "Rename Audio" |
*
* @param {Dialog_Rename_AudioInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const dialog_rename_audio = /** @type {((inputs?: Dialog_Rename_AudioInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialog_Rename_AudioInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_dialog_rename_audio(inputs)
	return en_dialog_rename_audio(inputs)
});